module.exports = __webpack_public_path__ + "images/directory/featured-hero/butler.227f71631cad43e34964.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/directory/featured-hero/butler.png
// module id = 8MWG
// module chunks = 2